// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension="
// @generated from file plans/v1/plans.proto (package plans.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from '@bufbuild/protobuf/codegenv2'
import { fileDesc, messageDesc, serviceDesc } from '@bufbuild/protobuf/codegenv2'
import { file_common_v1_annotations } from '../../common/v1/annotations_pb'
import { file_google_api_annotations } from '../../google/api/annotations_pb'
import type { Timestamp } from '@bufbuild/protobuf/wkt'
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file plans/v1/plans.proto.
 */
export const file_plans_v1_plans: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_common_v1_annotations, file_google_api_annotations, file_google_protobuf_timestamp]
  )

/**
 * Plan represents the plan or tier ex: Free Pro Enterprise
 *
 * @generated from message plans.v1.Plan
 */
export type Plan = Message<'plans.v1.Plan'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: string description = 3;
   */
  description: string

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 6;
   */
  deletedAt?: Timestamp

  /**
   * @generated from field: repeated plans.v1.Profile profiles = 8;
   */
  profiles: Profile[]
}

/**
 * Describes the message plans.v1.Plan.
 * Use `create(PlanSchema)` to create a new message.
 */
export const PlanSchema: GenMessage<Plan> = /*@__PURE__*/ messageDesc(file_plans_v1_plans, 0)

/**
 * GetPlanRequest is the request object to get a plan by id
 *
 * @generated from message plans.v1.GetPlanRequest
 */
export type GetPlanRequest = Message<'plans.v1.GetPlanRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message plans.v1.GetPlanRequest.
 * Use `create(GetPlanRequestSchema)` to create a new message.
 */
export const GetPlanRequestSchema: GenMessage<GetPlanRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 1)

/**
 * @generated from message plans.v1.GetPlanResponse
 */
export type GetPlanResponse = Message<'plans.v1.GetPlanResponse'> & {
  /**
   * @generated from field: plans.v1.Plan plan = 1;
   */
  plan?: Plan
}

/**
 * Describes the message plans.v1.GetPlanResponse.
 * Use `create(GetPlanResponseSchema)` to create a new message.
 */
export const GetPlanResponseSchema: GenMessage<GetPlanResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 2)

/**
 * CreatePlanResponse is the object holding a plan that is to be created
 *
 * @generated from message plans.v1.CreatePlanRequest
 */
export type CreatePlanRequest = Message<'plans.v1.CreatePlanRequest'> & {
  /**
   * @generated from field: plans.v1.Plan plan = 1;
   */
  plan?: Plan
}

/**
 * Describes the message plans.v1.CreatePlanRequest.
 * Use `create(CreatePlanRequestSchema)` to create a new message.
 */
export const CreatePlanRequestSchema: GenMessage<CreatePlanRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 3)

/**
 * CreatePlanResponse is the response to the create plan request sending back the id of the created
 * plan
 *
 * @generated from message plans.v1.CreatePlanResponse
 */
export type CreatePlanResponse = Message<'plans.v1.CreatePlanResponse'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message plans.v1.CreatePlanResponse.
 * Use `create(CreatePlanResponseSchema)` to create a new message.
 */
export const CreatePlanResponseSchema: GenMessage<CreatePlanResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 4)

/**
 * ListPlansRequest is an empty object, later we can fill it with filtering options
 *
 * @generated from message plans.v1.ListPlansRequest
 */
export type ListPlansRequest = Message<'plans.v1.ListPlansRequest'> & {}

/**
 * Describes the message plans.v1.ListPlansRequest.
 * Use `create(ListPlansRequestSchema)` to create a new message.
 */
export const ListPlansRequestSchema: GenMessage<ListPlansRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 5)

/**
 * ListPlansResponse returns an array of plans
 *
 * @generated from message plans.v1.ListPlansResponse
 */
export type ListPlansResponse = Message<'plans.v1.ListPlansResponse'> & {
  /**
   * @generated from field: repeated plans.v1.Plan items = 1;
   */
  items: Plan[]
}

/**
 * Describes the message plans.v1.ListPlansResponse.
 * Use `create(ListPlansResponseSchema)` to create a new message.
 */
export const ListPlansResponseSchema: GenMessage<ListPlansResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 6)

/**
 * ListPlanFeatureRequest request object to get features by plan
 *
 * @generated from message plans.v1.ListPlanFeaturesRequest
 */
export type ListPlanFeaturesRequest = Message<'plans.v1.ListPlanFeaturesRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message plans.v1.ListPlanFeaturesRequest.
 * Use `create(ListPlanFeaturesRequestSchema)` to create a new message.
 */
export const ListPlanFeaturesRequestSchema: GenMessage<ListPlanFeaturesRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 7)

/**
 * ListPlanFeatureResponse returns all features associated with a plan
 *
 * @generated from message plans.v1.ListPlanFeaturesResponse
 */
export type ListPlanFeaturesResponse = Message<'plans.v1.ListPlanFeaturesResponse'> & {
  /**
   * @generated from field: repeated plans.v1.Feature features = 1;
   */
  features: Feature[]
}

/**
 * Describes the message plans.v1.ListPlanFeaturesResponse.
 * Use `create(ListPlanFeaturesResponseSchema)` to create a new message.
 */
export const ListPlanFeaturesResponseSchema: GenMessage<ListPlanFeaturesResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 8)

/**
 * DeletePlanRequest holds an id which is then deleted from the database
 *
 * @generated from message plans.v1.DeletePlanRequest
 */
export type DeletePlanRequest = Message<'plans.v1.DeletePlanRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message plans.v1.DeletePlanRequest.
 * Use `create(DeletePlanRequestSchema)` to create a new message.
 */
export const DeletePlanRequestSchema: GenMessage<DeletePlanRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 9)

/**
 * DeletePlanResponse <haven't figured out what to put here yet>
 *
 * @generated from message plans.v1.DeletePlanResponse
 */
export type DeletePlanResponse = Message<'plans.v1.DeletePlanResponse'> & {}

/**
 * Describes the message plans.v1.DeletePlanResponse.
 * Use `create(DeletePlanResponseSchema)` to create a new message.
 */
export const DeletePlanResponseSchema: GenMessage<DeletePlanResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 10)

/**
 * Feature represents a features ie codes, analytics, api, pages etc
 *
 * @generated from message plans.v1.Feature
 */
export type Feature = Message<'plans.v1.Feature'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: string description = 3;
   */
  description: string

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 6;
   */
  deletedAt?: Timestamp

  /**
   * @generated from field: repeated plans.v1.Config configs = 7;
   */
  configs: Config[]
}

/**
 * Describes the message plans.v1.Feature.
 * Use `create(FeatureSchema)` to create a new message.
 */
export const FeatureSchema: GenMessage<Feature> = /*@__PURE__*/ messageDesc(file_plans_v1_plans, 11)

/**
 * GetFeatureRquest
 *
 * @generated from message plans.v1.GetFeatureRequest
 */
export type GetFeatureRequest = Message<'plans.v1.GetFeatureRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message plans.v1.GetFeatureRequest.
 * Use `create(GetFeatureRequestSchema)` to create a new message.
 */
export const GetFeatureRequestSchema: GenMessage<GetFeatureRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 12)

/**
 * GetFeatureResponse
 *
 * @generated from message plans.v1.GetFeatureResponse
 */
export type GetFeatureResponse = Message<'plans.v1.GetFeatureResponse'> & {
  /**
   * @generated from field: plans.v1.Feature feature = 1;
   */
  feature?: Feature
}

/**
 * Describes the message plans.v1.GetFeatureResponse.
 * Use `create(GetFeatureResponseSchema)` to create a new message.
 */
export const GetFeatureResponseSchema: GenMessage<GetFeatureResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 13)

/**
 * ListFeaturesRequest
 *
 * @generated from message plans.v1.ListFeaturesRequest
 */
export type ListFeaturesRequest = Message<'plans.v1.ListFeaturesRequest'> & {}

/**
 * Describes the message plans.v1.ListFeaturesRequest.
 * Use `create(ListFeaturesRequestSchema)` to create a new message.
 */
export const ListFeaturesRequestSchema: GenMessage<ListFeaturesRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 14)

/**
 * ListFeaturesResponse
 *
 * @generated from message plans.v1.ListFeaturesResponse
 */
export type ListFeaturesResponse = Message<'plans.v1.ListFeaturesResponse'> & {
  /**
   * @generated from field: repeated plans.v1.Feature items = 1;
   */
  items: Feature[]
}

/**
 * Describes the message plans.v1.ListFeaturesResponse.
 * Use `create(ListFeaturesResponseSchema)` to create a new message.
 */
export const ListFeaturesResponseSchema: GenMessage<ListFeaturesResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 15)

/**
 * DeleteFeaturesRequest
 *
 * @generated from message plans.v1.DeleteFeatureRequest
 */
export type DeleteFeatureRequest = Message<'plans.v1.DeleteFeatureRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message plans.v1.DeleteFeatureRequest.
 * Use `create(DeleteFeatureRequestSchema)` to create a new message.
 */
export const DeleteFeatureRequestSchema: GenMessage<DeleteFeatureRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 16)

/**
 * DeleteFeaturesResponse
 *
 * @generated from message plans.v1.DeleteFeatureResponse
 */
export type DeleteFeatureResponse = Message<'plans.v1.DeleteFeatureResponse'> & {}

/**
 * Describes the message plans.v1.DeleteFeatureResponse.
 * Use `create(DeleteFeatureResponseSchema)` to create a new message.
 */
export const DeleteFeatureResponseSchema: GenMessage<DeleteFeatureResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 17)

/**
 * @generated from message plans.v1.CreateFeatureResponse
 */
export type CreateFeatureResponse = Message<'plans.v1.CreateFeatureResponse'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string name = 2;
   */
  name: string
}

/**
 * Describes the message plans.v1.CreateFeatureResponse.
 * Use `create(CreateFeatureResponseSchema)` to create a new message.
 */
export const CreateFeatureResponseSchema: GenMessage<CreateFeatureResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 18)

/**
 * @generated from message plans.v1.CreateFeatureRequest
 */
export type CreateFeatureRequest = Message<'plans.v1.CreateFeatureRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: string description = 3;
   */
  description: string

  /**
   * @generated from field: repeated plans.v1.Config configs = 4;
   */
  configs: Config[]
}

/**
 * Describes the message plans.v1.CreateFeatureRequest.
 * Use `create(CreateFeatureRequestSchema)` to create a new message.
 */
export const CreateFeatureRequestSchema: GenMessage<CreateFeatureRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 19)

/**
 * Config
 *
 * @generated from message plans.v1.Config
 */
export type Config = Message<'plans.v1.Config'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: string description = 3;
   */
  description: string

  /**
   * @generated from field: string value_type = 4;
   */
  valueType: string

  /**
   * @generated from field: string calculation_type = 5;
   */
  calculationType: string

  /**
   * @generated from field: string feature_id = 6;
   */
  featureId: string

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 9;
   */
  deletedAt?: Timestamp
}

/**
 * Describes the message plans.v1.Config.
 * Use `create(ConfigSchema)` to create a new message.
 */
export const ConfigSchema: GenMessage<Config> = /*@__PURE__*/ messageDesc(file_plans_v1_plans, 20)

/**
 * GetConfigRequest
 *
 * @generated from message plans.v1.GetConfigRequest
 */
export type GetConfigRequest = Message<'plans.v1.GetConfigRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message plans.v1.GetConfigRequest.
 * Use `create(GetConfigRequestSchema)` to create a new message.
 */
export const GetConfigRequestSchema: GenMessage<GetConfigRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 21)

/**
 * GetConfigResponse
 *
 * @generated from message plans.v1.GetConfigResponse
 */
export type GetConfigResponse = Message<'plans.v1.GetConfigResponse'> & {
  /**
   * @generated from field: plans.v1.Config config = 1;
   */
  config?: Config
}

/**
 * Describes the message plans.v1.GetConfigResponse.
 * Use `create(GetConfigResponseSchema)` to create a new message.
 */
export const GetConfigResponseSchema: GenMessage<GetConfigResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 22)

/**
 * CreateConfigRequest
 *
 * @generated from message plans.v1.CreateConfigRequest
 */
export type CreateConfigRequest = Message<'plans.v1.CreateConfigRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: string value_type = 3;
   */
  valueType: string

  /**
   * @generated from field: string calculation_type = 4;
   */
  calculationType: string

  /**
   * @generated from field: string description = 5;
   */
  description: string

  /**
   * @generated from field: string feature_id = 6;
   */
  featureId: string
}

/**
 * Describes the message plans.v1.CreateConfigRequest.
 * Use `create(CreateConfigRequestSchema)` to create a new message.
 */
export const CreateConfigRequestSchema: GenMessage<CreateConfigRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 23)

/**
 * CreateConfigResponse
 *
 * @generated from message plans.v1.CreateConfigResponse
 */
export type CreateConfigResponse = Message<'plans.v1.CreateConfigResponse'> & {
  /**
   * @generated from field: plans.v1.Config config = 1;
   */
  config?: Config
}

/**
 * Describes the message plans.v1.CreateConfigResponse.
 * Use `create(CreateConfigResponseSchema)` to create a new message.
 */
export const CreateConfigResponseSchema: GenMessage<CreateConfigResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 24)

/**
 * ListConfigsRequest
 *
 * @generated from message plans.v1.ListConfigsRequest
 */
export type ListConfigsRequest = Message<'plans.v1.ListConfigsRequest'> & {}

/**
 * Describes the message plans.v1.ListConfigsRequest.
 * Use `create(ListConfigsRequestSchema)` to create a new message.
 */
export const ListConfigsRequestSchema: GenMessage<ListConfigsRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 25)

/**
 * ListConfigsResponse
 *
 * @generated from message plans.v1.ListConfigsResponse
 */
export type ListConfigsResponse = Message<'plans.v1.ListConfigsResponse'> & {
  /**
   * @generated from field: repeated plans.v1.Config items = 1;
   */
  items: Config[]
}

/**
 * Describes the message plans.v1.ListConfigsResponse.
 * Use `create(ListConfigsResponseSchema)` to create a new message.
 */
export const ListConfigsResponseSchema: GenMessage<ListConfigsResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 26)

/**
 * UpdateConfigRequest
 *
 * @generated from message plans.v1.UpdateConfigRequest
 */
export type UpdateConfigRequest = Message<'plans.v1.UpdateConfigRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string

  /**
   * @generated from field: optional string value_type = 4;
   */
  valueType?: string

  /**
   * @generated from field: optional string calculation_type = 5;
   */
  calculationType?: string

  /**
   * @generated from field: optional string feature_id = 6;
   */
  featureId?: string
}

/**
 * Describes the message plans.v1.UpdateConfigRequest.
 * Use `create(UpdateConfigRequestSchema)` to create a new message.
 */
export const UpdateConfigRequestSchema: GenMessage<UpdateConfigRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 27)

/**
 * UpdateConfigResponse
 *
 * @generated from message plans.v1.UpdateConfigResponse
 */
export type UpdateConfigResponse = Message<'plans.v1.UpdateConfigResponse'> & {
  /**
   * @generated from field: plans.v1.Config config = 1;
   */
  config?: Config
}

/**
 * Describes the message plans.v1.UpdateConfigResponse.
 * Use `create(UpdateConfigResponseSchema)` to create a new message.
 */
export const UpdateConfigResponseSchema: GenMessage<UpdateConfigResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 28)

/**
 * DeleteConfigRequest
 *
 * @generated from message plans.v1.DeleteConfigRequest
 */
export type DeleteConfigRequest = Message<'plans.v1.DeleteConfigRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message plans.v1.DeleteConfigRequest.
 * Use `create(DeleteConfigRequestSchema)` to create a new message.
 */
export const DeleteConfigRequestSchema: GenMessage<DeleteConfigRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 29)

/**
 * DeleteConfigResponse
 *
 * @generated from message plans.v1.DeleteConfigResponse
 */
export type DeleteConfigResponse = Message<'plans.v1.DeleteConfigResponse'> & {}

/**
 * Describes the message plans.v1.DeleteConfigResponse.
 * Use `create(DeleteConfigResponseSchema)` to create a new message.
 */
export const DeleteConfigResponseSchema: GenMessage<DeleteConfigResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 30)

/**
 * Profile
 *
 * @generated from message plans.v1.Profile
 */
export type Profile = Message<'plans.v1.Profile'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: string plan_id = 3;
   */
  planId: string

  /**
   * @generated from field: bool default_profile = 4;
   */
  defaultProfile: boolean

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 7;
   */
  deletedAt?: Timestamp
}

/**
 * Describes the message plans.v1.Profile.
 * Use `create(ProfileSchema)` to create a new message.
 */
export const ProfileSchema: GenMessage<Profile> = /*@__PURE__*/ messageDesc(file_plans_v1_plans, 31)

/**
 * GetProfileRequest
 *
 * @generated from message plans.v1.GetProfileRequest
 */
export type GetProfileRequest = Message<'plans.v1.GetProfileRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message plans.v1.GetProfileRequest.
 * Use `create(GetProfileRequestSchema)` to create a new message.
 */
export const GetProfileRequestSchema: GenMessage<GetProfileRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 32)

/**
 * GetProfileResponse
 *
 * @generated from message plans.v1.GetProfileResponse
 */
export type GetProfileResponse = Message<'plans.v1.GetProfileResponse'> & {
  /**
   * @generated from field: plans.v1.Profile profile = 1;
   */
  profile?: Profile
}

/**
 * Describes the message plans.v1.GetProfileResponse.
 * Use `create(GetProfileResponseSchema)` to create a new message.
 */
export const GetProfileResponseSchema: GenMessage<GetProfileResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 33)

/**
 * CreateProfileRequest
 *
 * @generated from message plans.v1.CreateProfileRequest
 */
export type CreateProfileRequest = Message<'plans.v1.CreateProfileRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: string plan_id = 3;
   */
  planId: string

  /**
   * @generated from field: bool default_profile = 4;
   */
  defaultProfile: boolean
}

/**
 * Describes the message plans.v1.CreateProfileRequest.
 * Use `create(CreateProfileRequestSchema)` to create a new message.
 */
export const CreateProfileRequestSchema: GenMessage<CreateProfileRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 34)

/**
 * CreateProfileResponse
 *
 * @generated from message plans.v1.CreateProfileResponse
 */
export type CreateProfileResponse = Message<'plans.v1.CreateProfileResponse'> & {
  /**
   * @generated from field: plans.v1.Profile profile = 1;
   */
  profile?: Profile
}

/**
 * Describes the message plans.v1.CreateProfileResponse.
 * Use `create(CreateProfileResponseSchema)` to create a new message.
 */
export const CreateProfileResponseSchema: GenMessage<CreateProfileResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 35)

/**
 * UpdateProfileRequest
 *
 * @generated from message plans.v1.UpdateProfileRequest
 */
export type UpdateProfileRequest = Message<'plans.v1.UpdateProfileRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string name = 2;
   */
  name: string

  /**
   * @generated from field: string plan_id = 3;
   */
  planId: string

  /**
   * @generated from field: bool default_profile = 4;
   */
  defaultProfile: boolean
}

/**
 * Describes the message plans.v1.UpdateProfileRequest.
 * Use `create(UpdateProfileRequestSchema)` to create a new message.
 */
export const UpdateProfileRequestSchema: GenMessage<UpdateProfileRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 36)

/**
 * UpdateProfileResponse
 *
 * @generated from message plans.v1.UpdateProfileResponse
 */
export type UpdateProfileResponse = Message<'plans.v1.UpdateProfileResponse'> & {
  /**
   * @generated from field: plans.v1.Profile profile = 1;
   */
  profile?: Profile
}

/**
 * Describes the message plans.v1.UpdateProfileResponse.
 * Use `create(UpdateProfileResponseSchema)` to create a new message.
 */
export const UpdateProfileResponseSchema: GenMessage<UpdateProfileResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 37)

/**
 * ListProfilesRequest
 *
 * @generated from message plans.v1.ListProfilesRequest
 */
export type ListProfilesRequest = Message<'plans.v1.ListProfilesRequest'> & {}

/**
 * Describes the message plans.v1.ListProfilesRequest.
 * Use `create(ListProfilesRequestSchema)` to create a new message.
 */
export const ListProfilesRequestSchema: GenMessage<ListProfilesRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 38)

/**
 * ListProfilesResponse
 *
 * @generated from message plans.v1.ListProfilesResponse
 */
export type ListProfilesResponse = Message<'plans.v1.ListProfilesResponse'> & {
  /**
   * @generated from field: repeated plans.v1.Profile items = 1;
   */
  items: Profile[]
}

/**
 * Describes the message plans.v1.ListProfilesResponse.
 * Use `create(ListProfilesResponseSchema)` to create a new message.
 */
export const ListProfilesResponseSchema: GenMessage<ListProfilesResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 39)

/**
 * DeleteProfileRequest
 *
 * @generated from message plans.v1.DeleteProfileRequest
 */
export type DeleteProfileRequest = Message<'plans.v1.DeleteProfileRequest'> & {
  /**
   * @generated from field: string profile_id = 1;
   */
  profileId: string

  /**
   * @generated from field: string plan_id = 2;
   */
  planId: string
}

/**
 * Describes the message plans.v1.DeleteProfileRequest.
 * Use `create(DeleteProfileRequestSchema)` to create a new message.
 */
export const DeleteProfileRequestSchema: GenMessage<DeleteProfileRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 40)

/**
 * DeleteProfileResponse
 *
 * @generated from message plans.v1.DeleteProfileResponse
 */
export type DeleteProfileResponse = Message<'plans.v1.DeleteProfileResponse'> & {}

/**
 * Describes the message plans.v1.DeleteProfileResponse.
 * Use `create(DeleteProfileResponseSchema)` to create a new message.
 */
export const DeleteProfileResponseSchema: GenMessage<DeleteProfileResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 41)

/**
 * Config
 *
 * @generated from message plans.v1.ProfileConfig
 */
export type ProfileConfig = Message<'plans.v1.ProfileConfig'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string profile_id = 2;
   */
  profileId: string

  /**
   * @generated from field: string config_id = 3;
   */
  configId: string

  /**
   * @generated from field: string config_value = 4;
   */
  configValue: string

  /**
   * @generated from field: string feature_id = 5;
   */
  featureId: string

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 8;
   */
  deletedAt?: Timestamp
}

/**
 * Describes the message plans.v1.ProfileConfig.
 * Use `create(ProfileConfigSchema)` to create a new message.
 */
export const ProfileConfigSchema: GenMessage<ProfileConfig> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 42)

/**
 * @generated from message plans.v1.UpdateProfileConfigRequest
 */
export type UpdateProfileConfigRequest = Message<'plans.v1.UpdateProfileConfigRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string profile_id = 2;
   */
  profileId: string

  /**
   * @generated from field: string config_id = 3;
   */
  configId: string

  /**
   * @generated from field: string config_value = 4;
   */
  configValue: string

  /**
   * @generated from field: optional string feature_id = 5;
   */
  featureId?: string
}

/**
 * Describes the message plans.v1.UpdateProfileConfigRequest.
 * Use `create(UpdateProfileConfigRequestSchema)` to create a new message.
 */
export const UpdateProfileConfigRequestSchema: GenMessage<UpdateProfileConfigRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 43)

/**
 * @generated from message plans.v1.UpdateProfileConfigResponse
 */
export type UpdateProfileConfigResponse = Message<'plans.v1.UpdateProfileConfigResponse'> & {
  /**
   * @generated from field: plans.v1.ProfileConfig profile_config = 1;
   */
  profileConfig?: ProfileConfig
}

/**
 * Describes the message plans.v1.UpdateProfileConfigResponse.
 * Use `create(UpdateProfileConfigResponseSchema)` to create a new message.
 */
export const UpdateProfileConfigResponseSchema: GenMessage<UpdateProfileConfigResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 44)

/**
 * ListProfileConfigsRequest
 *
 * @generated from message plans.v1.ListProfileConfigsRequest
 */
export type ListProfileConfigsRequest = Message<'plans.v1.ListProfileConfigsRequest'> & {
  /**
   * @generated from field: string plan_id = 1;
   */
  planId: string

  /**
   * @generated from field: string profile_id = 2;
   */
  profileId: string
}

/**
 * Describes the message plans.v1.ListProfileConfigsRequest.
 * Use `create(ListProfileConfigsRequestSchema)` to create a new message.
 */
export const ListProfileConfigsRequestSchema: GenMessage<ListProfileConfigsRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 45)

/**
 * ListProfileConfigsResponse
 *
 * @generated from message plans.v1.ListProfileConfigsResponse
 */
export type ListProfileConfigsResponse = Message<'plans.v1.ListProfileConfigsResponse'> & {
  /**
   * @generated from field: repeated plans.v1.ProfileConfig items = 1;
   */
  items: ProfileConfig[]
}

/**
 * Describes the message plans.v1.ListProfileConfigsResponse.
 * Use `create(ListProfileConfigsResponseSchema)` to create a new message.
 */
export const ListProfileConfigsResponseSchema: GenMessage<ListProfileConfigsResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 46)

/**
 * ProfileOverride allows individual overrides of config values for a given profile on a per
 * org basis
 *
 * @generated from message plans.v1.ProfileOverride
 */
export type ProfileOverride = Message<'plans.v1.ProfileOverride'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string config_id = 2;
   */
  configId: string

  /**
   * @generated from field: string org_id = 3;
   */
  orgId: string

  /**
   * @generated from field: string config_value = 4;
   */
  configValue: string

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 7;
   */
  deletedAt?: Timestamp
}

/**
 * Describes the message plans.v1.ProfileOverride.
 * Use `create(ProfileOverrideSchema)` to create a new message.
 */
export const ProfileOverrideSchema: GenMessage<ProfileOverride> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 47)

/**
 * @generated from message plans.v1.CreateProfileOverrideRequest
 */
export type CreateProfileOverrideRequest = Message<'plans.v1.CreateProfileOverrideRequest'> & {
  /**
   * @generated from field: string config_id = 1;
   */
  configId: string

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string

  /**
   * @generated from field: string config_value = 3;
   */
  configValue: string
}

/**
 * Describes the message plans.v1.CreateProfileOverrideRequest.
 * Use `create(CreateProfileOverrideRequestSchema)` to create a new message.
 */
export const CreateProfileOverrideRequestSchema: GenMessage<CreateProfileOverrideRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 48)

/**
 * @generated from message plans.v1.CreateProfileOverrideResponse
 */
export type CreateProfileOverrideResponse = Message<'plans.v1.CreateProfileOverrideResponse'> & {
  /**
   * @generated from field: plans.v1.ProfileOverride profile_override = 1;
   */
  profileOverride?: ProfileOverride
}

/**
 * Describes the message plans.v1.CreateProfileOverrideResponse.
 * Use `create(CreateProfileOverrideResponseSchema)` to create a new message.
 */
export const CreateProfileOverrideResponseSchema: GenMessage<CreateProfileOverrideResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 49)

/**
 * @generated from message plans.v1.UpdateProfileOverrideRequest
 */
export type UpdateProfileOverrideRequest = Message<'plans.v1.UpdateProfileOverrideRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string

  /**
   * @generated from field: string config_value = 3;
   */
  configValue: string
}

/**
 * Describes the message plans.v1.UpdateProfileOverrideRequest.
 * Use `create(UpdateProfileOverrideRequestSchema)` to create a new message.
 */
export const UpdateProfileOverrideRequestSchema: GenMessage<UpdateProfileOverrideRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 50)

/**
 * @generated from message plans.v1.UpdateProfileOverrideResponse
 */
export type UpdateProfileOverrideResponse = Message<'plans.v1.UpdateProfileOverrideResponse'> & {
  /**
   * @generated from field: plans.v1.ProfileOverride profile_override = 1;
   */
  profileOverride?: ProfileOverride
}

/**
 * Describes the message plans.v1.UpdateProfileOverrideResponse.
 * Use `create(UpdateProfileOverrideResponseSchema)` to create a new message.
 */
export const UpdateProfileOverrideResponseSchema: GenMessage<UpdateProfileOverrideResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 51)

/**
 * DeleteProfileOverrideRequest
 *
 * @generated from message plans.v1.DeleteProfileOverrideRequest
 */
export type DeleteProfileOverrideRequest = Message<'plans.v1.DeleteProfileOverrideRequest'> & {
  /**
   * @generated from field: string profile_override_id = 1;
   */
  profileOverrideId: string
}

/**
 * Describes the message plans.v1.DeleteProfileOverrideRequest.
 * Use `create(DeleteProfileOverrideRequestSchema)` to create a new message.
 */
export const DeleteProfileOverrideRequestSchema: GenMessage<DeleteProfileOverrideRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 52)

/**
 * DeleteProfileOverrideResponse
 *
 * @generated from message plans.v1.DeleteProfileOverrideResponse
 */
export type DeleteProfileOverrideResponse = Message<'plans.v1.DeleteProfileOverrideResponse'> & {}

/**
 * Describes the message plans.v1.DeleteProfileOverrideResponse.
 * Use `create(DeleteProfileOverrideResponseSchema)` to create a new message.
 */
export const DeleteProfileOverrideResponseSchema: GenMessage<DeleteProfileOverrideResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 53)

/**
 * ListProfileOverridesRequest
 *
 * @generated from message plans.v1.ListProfileOverridesRequest
 */
export type ListProfileOverridesRequest = Message<'plans.v1.ListProfileOverridesRequest'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string
}

/**
 * Describes the message plans.v1.ListProfileOverridesRequest.
 * Use `create(ListProfileOverridesRequestSchema)` to create a new message.
 */
export const ListProfileOverridesRequestSchema: GenMessage<ListProfileOverridesRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 54)

/**
 * ListProfileOverridesResponse
 *
 * @generated from message plans.v1.ListProfileOverridesResponse
 */
export type ListProfileOverridesResponse = Message<'plans.v1.ListProfileOverridesResponse'> & {
  /**
   * @generated from field: repeated plans.v1.ProfileOverride items = 1;
   */
  items: ProfileOverride[]
}

/**
 * Describes the message plans.v1.ListProfileOverridesResponse.
 * Use `create(ListProfileOverridesResponseSchema)` to create a new message.
 */
export const ListProfileOverridesResponseSchema: GenMessage<ListProfileOverridesResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 55)

/**
 * FeatureOverride
 *
 * @generated from message plans.v1.FeatureOverride
 */
export type FeatureOverride = Message<'plans.v1.FeatureOverride'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string feature_id = 2;
   */
  featureId: string

  /**
   * @generated from field: string org_id = 3;
   */
  orgId: string

  /**
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 7;
   */
  deletedAt?: Timestamp
}

/**
 * Describes the message plans.v1.FeatureOverride.
 * Use `create(FeatureOverrideSchema)` to create a new message.
 */
export const FeatureOverrideSchema: GenMessage<FeatureOverride> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 56)

/**
 * ListFeatureOverridesRequest
 *
 * @generated from message plans.v1.ListFeatureOverridesRequest
 */
export type ListFeatureOverridesRequest = Message<'plans.v1.ListFeatureOverridesRequest'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string
}

/**
 * Describes the message plans.v1.ListFeatureOverridesRequest.
 * Use `create(ListFeatureOverridesRequestSchema)` to create a new message.
 */
export const ListFeatureOverridesRequestSchema: GenMessage<ListFeatureOverridesRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 57)

/**
 * ListFeatureOverridesResponse
 *
 * @generated from message plans.v1.ListFeatureOverridesResponse
 */
export type ListFeatureOverridesResponse = Message<'plans.v1.ListFeatureOverridesResponse'> & {
  /**
   * @generated from field: repeated plans.v1.FeatureOverride items = 1;
   */
  items: FeatureOverride[]
}

/**
 * Describes the message plans.v1.ListFeatureOverridesResponse.
 * Use `create(ListFeatureOverridesResponseSchema)` to create a new message.
 */
export const ListFeatureOverridesResponseSchema: GenMessage<ListFeatureOverridesResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 58)

/**
 * UpdateFeatureOverrideResponse
 *
 * @generated from message plans.v1.UpdateFeatureOverrideResponse
 */
export type UpdateFeatureOverrideResponse = Message<'plans.v1.UpdateFeatureOverrideResponse'> & {
  /**
   * @generated from field: plans.v1.FeatureOverride feature_override = 1;
   */
  featureOverride?: FeatureOverride
}

/**
 * Describes the message plans.v1.UpdateFeatureOverrideResponse.
 * Use `create(UpdateFeatureOverrideResponseSchema)` to create a new message.
 */
export const UpdateFeatureOverrideResponseSchema: GenMessage<UpdateFeatureOverrideResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 59)

/**
 * DeleteFeatureOverrideRequest
 *
 * @generated from message plans.v1.DeleteFeatureOverrideRequest
 */
export type DeleteFeatureOverrideRequest = Message<'plans.v1.DeleteFeatureOverrideRequest'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string

  /**
   * @generated from field: string override_id = 2;
   */
  overrideId: string

  /**
   * @generated from field: string feature_id = 3;
   */
  featureId: string
}

/**
 * Describes the message plans.v1.DeleteFeatureOverrideRequest.
 * Use `create(DeleteFeatureOverrideRequestSchema)` to create a new message.
 */
export const DeleteFeatureOverrideRequestSchema: GenMessage<DeleteFeatureOverrideRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 60)

/**
 * DeleteFeatureOverrideResponse
 *
 * @generated from message plans.v1.DeleteFeatureOverrideResponse
 */
export type DeleteFeatureOverrideResponse = Message<'plans.v1.DeleteFeatureOverrideResponse'> & {}

/**
 * Describes the message plans.v1.DeleteFeatureOverrideResponse.
 * Use `create(DeleteFeatureOverrideResponseSchema)` to create a new message.
 */
export const DeleteFeatureOverrideResponseSchema: GenMessage<DeleteFeatureOverrideResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 61)

/**
 * CreateFeatureOverrideRequest
 *
 * @generated from message plans.v1.CreateFeatureOverrideRequest
 */
export type CreateFeatureOverrideRequest = Message<'plans.v1.CreateFeatureOverrideRequest'> & {
  /**
   * @generated from field: string feature_id = 1;
   */
  featureId: string

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string

  /**
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean
}

/**
 * Describes the message plans.v1.CreateFeatureOverrideRequest.
 * Use `create(CreateFeatureOverrideRequestSchema)` to create a new message.
 */
export const CreateFeatureOverrideRequestSchema: GenMessage<CreateFeatureOverrideRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 62)

/**
 * CreateFeatureOverrideResponse
 *
 * @generated from message plans.v1.CreateFeatureOverrideResponse
 */
export type CreateFeatureOverrideResponse = Message<'plans.v1.CreateFeatureOverrideResponse'> & {
  /**
   * @generated from field: plans.v1.FeatureOverride feature_override = 1;
   */
  featureOverride?: FeatureOverride
}

/**
 * Describes the message plans.v1.CreateFeatureOverrideResponse.
 * Use `create(CreateFeatureOverrideResponseSchema)` to create a new message.
 */
export const CreateFeatureOverrideResponseSchema: GenMessage<CreateFeatureOverrideResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 63)

/**
 * @generated from message plans.v1.Cachable
 */
export type Cachable = Message<'plans.v1.Cachable'> & {
  /**
   * @generated from field: string config_name = 1;
   */
  configName: string

  /**
   * @generated from field: string calculation_type = 2;
   */
  calculationType: string

  /**
   * @generated from field: string value = 3;
   */
  value: string

  /**
   * @generated from field: int64 current_use = 4;
   */
  currentUse: bigint
}

/**
 * Describes the message plans.v1.Cachable.
 * Use `create(CachableSchema)` to create a new message.
 */
export const CachableSchema: GenMessage<Cachable> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 64)

/**
 * @generated from message plans.v1.ListOfCached
 */
export type ListOfCached = Message<'plans.v1.ListOfCached'> & {
  /**
   * @generated from field: repeated plans.v1.Cachable cached = 1;
   */
  cached: Cachable[]
}

/**
 * Describes the message plans.v1.ListOfCached.
 * Use `create(ListOfCachedSchema)` to create a new message.
 */
export const ListOfCachedSchema: GenMessage<ListOfCached> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 65)

/**
 * @generated from message plans.v1.UsageResult
 */
export type UsageResult = Message<'plans.v1.UsageResult'> & {
  /**
   * @generated from field: map<string, plans.v1.ListOfCached> feature_results = 1;
   */
  featureResults: { [key: string]: ListOfCached }
}

/**
 * Describes the message plans.v1.UsageResult.
 * Use `create(UsageResultSchema)` to create a new message.
 */
export const UsageResultSchema: GenMessage<UsageResult> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 66)

/**
 * @generated from message plans.v1.GetUsageRequest
 */
export type GetUsageRequest = Message<'plans.v1.GetUsageRequest'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string

  /**
   * @generated from field: string plan_id = 2;
   */
  planId: string
}

/**
 * Describes the message plans.v1.GetUsageRequest.
 * Use `create(GetUsageRequestSchema)` to create a new message.
 */
export const GetUsageRequestSchema: GenMessage<GetUsageRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 67)

/**
 * @generated from message plans.v1.GetUsageResponse
 */
export type GetUsageResponse = Message<'plans.v1.GetUsageResponse'> & {
  /**
   * @generated from field: map<string, plans.v1.ListOfCached> feature_usage = 1;
   */
  featureUsage: { [key: string]: ListOfCached }
}

/**
 * Describes the message plans.v1.GetUsageResponse.
 * Use `create(GetUsageResponseSchema)` to create a new message.
 */
export const GetUsageResponseSchema: GenMessage<GetUsageResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 68)

/**
 * @generated from message plans.v1.MaterializedConfig
 */
export type MaterializedConfig = Message<'plans.v1.MaterializedConfig'> & {
  /**
   * @generated from field: string config_id = 1;
   */
  configId: string

  /**
   * @generated from field: string config_name = 2;
   */
  configName: string

  /**
   * @generated from field: string profile_config_id = 3;
   */
  profileConfigId: string

  /**
   * @generated from field: string config_value = 4;
   */
  configValue: string

  /**
   * @generated from field: string calculation_type = 5;
   */
  calculationType: string

  /**
   * @generated from field: string override_id = 6;
   */
  overrideId: string
}

/**
 * Describes the message plans.v1.MaterializedConfig.
 * Use `create(MaterializedConfigSchema)` to create a new message.
 */
export const MaterializedConfigSchema: GenMessage<MaterializedConfig> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 69)

/**
 * @generated from message plans.v1.MaterializedFeature
 */
export type MaterializedFeature = Message<'plans.v1.MaterializedFeature'> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string

  /**
   * @generated from field: string description = 2;
   */
  description: string

  /**
   * @generated from field: string feature_id = 3;
   */
  featureId: string

  /**
   * @generated from field: string feature_override_id = 4;
   */
  featureOverrideId: string

  /**
   * @generated from field: bool enabled = 5;
   */
  enabled: boolean

  /**
   * @generated from field: repeated plans.v1.MaterializedConfig configs = 6;
   */
  configs: MaterializedConfig[]
}

/**
 * Describes the message plans.v1.MaterializedFeature.
 * Use `create(MaterializedFeatureSchema)` to create a new message.
 */
export const MaterializedFeatureSchema: GenMessage<MaterializedFeature> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 70)

/**
 * @generated from message plans.v1.OrgProfile
 */
export type OrgProfile = Message<'plans.v1.OrgProfile'> & {
  /**
   * @generated from field: repeated plans.v1.MaterializedFeature features = 1;
   */
  features: MaterializedFeature[]
}

/**
 * Describes the message plans.v1.OrgProfile.
 * Use `create(OrgProfileSchema)` to create a new message.
 */
export const OrgProfileSchema: GenMessage<OrgProfile> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 71)

/**
 * @generated from message plans.v1.ListOrgProfileRequest
 */
export type ListOrgProfileRequest = Message<'plans.v1.ListOrgProfileRequest'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string
}

/**
 * Describes the message plans.v1.ListOrgProfileRequest.
 * Use `create(ListOrgProfileRequestSchema)` to create a new message.
 */
export const ListOrgProfileRequestSchema: GenMessage<ListOrgProfileRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 72)

/**
 * @generated from message plans.v1.ListOrgProfileResponse
 */
export type ListOrgProfileResponse = Message<'plans.v1.ListOrgProfileResponse'> & {
  /**
   * @generated from field: repeated plans.v1.MaterializedFeature features = 1;
   */
  features: MaterializedFeature[]
}

/**
 * Describes the message plans.v1.ListOrgProfileResponse.
 * Use `create(ListOrgProfileResponseSchema)` to create a new message.
 */
export const ListOrgProfileResponseSchema: GenMessage<ListOrgProfileResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 73)

/**
 * OrgProfileLink maps an organizations plan profile
 * org basis
 *
 * @generated from message plans.v1.OrgLink
 */
export type OrgLink = Message<'plans.v1.OrgLink'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string profile_id = 2;
   */
  profileId: string

  /**
   * @generated from field: bool active = 3;
   */
  active: boolean

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp

  /**
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 6;
   */
  deletedAt?: Timestamp

  /**
   * @generated from field: plans.v1.Plan plan = 7;
   */
  plan?: Plan
}

/**
 * Describes the message plans.v1.OrgLink.
 * Use `create(OrgLinkSchema)` to create a new message.
 */
export const OrgLinkSchema: GenMessage<OrgLink> = /*@__PURE__*/ messageDesc(file_plans_v1_plans, 74)

/**
 * @generated from message plans.v1.CreateOrgLinkRequest
 */
export type CreateOrgLinkRequest = Message<'plans.v1.CreateOrgLinkRequest'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string

  /**
   * @generated from field: string plan_name = 2;
   */
  planName: string

  /**
   * @generated from field: bool active = 3;
   */
  active: boolean
}

/**
 * Describes the message plans.v1.CreateOrgLinkRequest.
 * Use `create(CreateOrgLinkRequestSchema)` to create a new message.
 */
export const CreateOrgLinkRequestSchema: GenMessage<CreateOrgLinkRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 75)

/**
 * @generated from message plans.v1.CreateOrgLinkResponse
 */
export type CreateOrgLinkResponse = Message<'plans.v1.CreateOrgLinkResponse'> & {}

/**
 * Describes the message plans.v1.CreateOrgLinkResponse.
 * Use `create(CreateOrgLinkResponseSchema)` to create a new message.
 */
export const CreateOrgLinkResponseSchema: GenMessage<CreateOrgLinkResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 76)

/**
 * @generated from message plans.v1.GetOrgLinkRequest
 */
export type GetOrgLinkRequest = Message<'plans.v1.GetOrgLinkRequest'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string
}

/**
 * Describes the message plans.v1.GetOrgLinkRequest.
 * Use `create(GetOrgLinkRequestSchema)` to create a new message.
 */
export const GetOrgLinkRequestSchema: GenMessage<GetOrgLinkRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 77)

/**
 * @generated from message plans.v1.GetOrgLinkResponse
 */
export type GetOrgLinkResponse = Message<'plans.v1.GetOrgLinkResponse'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string

  /**
   * @generated from field: bool active = 2;
   */
  active: boolean

  /**
   * @generated from field: string profile_id = 3;
   */
  profileId: string

  /**
   * @generated from field: string plan_id = 4;
   */
  planId: string

  /**
   * @generated from field: string plan_name = 5;
   */
  planName: string
}

/**
 * Describes the message plans.v1.GetOrgLinkResponse.
 * Use `create(GetOrgLinkResponseSchema)` to create a new message.
 */
export const GetOrgLinkResponseSchema: GenMessage<GetOrgLinkResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 78)

/**
 * @generated from message plans.v1.IsActiveRequest
 */
export type IsActiveRequest = Message<'plans.v1.IsActiveRequest'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string
}

/**
 * Describes the message plans.v1.IsActiveRequest.
 * Use `create(IsActiveRequestSchema)` to create a new message.
 */
export const IsActiveRequestSchema: GenMessage<IsActiveRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 79)

/**
 * @generated from message plans.v1.IsActiveResponse
 */
export type IsActiveResponse = Message<'plans.v1.IsActiveResponse'> & {
  /**
   * @generated from field: bool active = 1;
   */
  active: boolean
}

/**
 * Describes the message plans.v1.IsActiveResponse.
 * Use `create(IsActiveResponseSchema)` to create a new message.
 */
export const IsActiveResponseSchema: GenMessage<IsActiveResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 80)

/**
 * @generated from message plans.v1.IsEntitledRequest
 */
export type IsEntitledRequest = Message<'plans.v1.IsEntitledRequest'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string

  /**
   * @generated from field: string path = 2;
   */
  path: string

  /**
   * @generated from field: optional string value = 3;
   */
  value?: string
}

/**
 * Describes the message plans.v1.IsEntitledRequest.
 * Use `create(IsEntitledRequestSchema)` to create a new message.
 */
export const IsEntitledRequestSchema: GenMessage<IsEntitledRequest> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 81)

/**
 * @generated from message plans.v1.IsEntitledResponse
 */
export type IsEntitledResponse = Message<'plans.v1.IsEntitledResponse'> & {
  /**
   * @generated from field: bool entitled = 1;
   */
  entitled: boolean

  /**
   * @generated from field: string value = 2;
   */
  value: string
}

/**
 * Describes the message plans.v1.IsEntitledResponse.
 * Use `create(IsEntitledResponseSchema)` to create a new message.
 */
export const IsEntitledResponseSchema: GenMessage<IsEntitledResponse> =
  /*@__PURE__*/
  messageDesc(file_plans_v1_plans, 82)

/**
 * @generated from service plans.v1.PlansService
 */
export const PlansService: GenService<{
  /**
   * @generated from rpc plans.v1.PlansService.CreateOrgLink
   */
  createOrgLink: {
    methodKind: 'unary'
    input: typeof CreateOrgLinkRequestSchema
    output: typeof CreateOrgLinkResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.GetOrgLink
   */
  getOrgLink: {
    methodKind: 'unary'
    input: typeof GetOrgLinkRequestSchema
    output: typeof GetOrgLinkResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.IsActive
   */
  isActive: {
    methodKind: 'unary'
    input: typeof IsActiveRequestSchema
    output: typeof IsActiveResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.GetPlan
   */
  getPlan: {
    methodKind: 'unary'
    input: typeof GetPlanRequestSchema
    output: typeof GetPlanResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.ListPlans
   */
  listPlans: {
    methodKind: 'unary'
    input: typeof ListPlansRequestSchema
    output: typeof ListPlansResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.CreatePlan
   */
  createPlan: {
    methodKind: 'unary'
    input: typeof CreatePlanRequestSchema
    output: typeof CreatePlanResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.DeletePlan
   */
  deletePlan: {
    methodKind: 'unary'
    input: typeof DeletePlanRequestSchema
    output: typeof DeletePlanResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.GetFeature
   */
  getFeature: {
    methodKind: 'unary'
    input: typeof GetFeatureRequestSchema
    output: typeof GetFeatureResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.ListFeatures
   */
  listFeatures: {
    methodKind: 'unary'
    input: typeof ListFeaturesRequestSchema
    output: typeof ListFeaturesResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.CreateFeature
   */
  createFeature: {
    methodKind: 'unary'
    input: typeof CreateFeatureRequestSchema
    output: typeof CreateFeatureResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.DeleteFeature
   */
  deleteFeature: {
    methodKind: 'unary'
    input: typeof DeleteFeatureRequestSchema
    output: typeof DeleteFeatureResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.GetConfig
   */
  getConfig: {
    methodKind: 'unary'
    input: typeof GetConfigRequestSchema
    output: typeof GetConfigResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.UpdateConfig
   */
  updateConfig: {
    methodKind: 'unary'
    input: typeof UpdateConfigRequestSchema
    output: typeof UpdateConfigResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.ListConfigs
   */
  listConfigs: {
    methodKind: 'unary'
    input: typeof ListConfigsRequestSchema
    output: typeof ListConfigsResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.CreateConfig
   */
  createConfig: {
    methodKind: 'unary'
    input: typeof CreateConfigRequestSchema
    output: typeof CreateConfigResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.DeleteConfig
   */
  deleteConfig: {
    methodKind: 'unary'
    input: typeof DeleteConfigRequestSchema
    output: typeof DeleteConfigResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.GetProfile
   */
  getProfile: {
    methodKind: 'unary'
    input: typeof GetProfileRequestSchema
    output: typeof GetProfileResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.ListProfiles
   */
  listProfiles: {
    methodKind: 'unary'
    input: typeof ListProfilesRequestSchema
    output: typeof ListProfilesResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.CreateProfile
   */
  createProfile: {
    methodKind: 'unary'
    input: typeof CreateProfileRequestSchema
    output: typeof CreateProfileResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.DeleteProfile
   */
  deleteProfile: {
    methodKind: 'unary'
    input: typeof DeleteProfileRequestSchema
    output: typeof DeleteProfileResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.UpdateProfileConfig
   */
  updateProfileConfig: {
    methodKind: 'unary'
    input: typeof UpdateProfileConfigRequestSchema
    output: typeof UpdateProfileConfigResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.ListProfileConfigs
   */
  listProfileConfigs: {
    methodKind: 'unary'
    input: typeof ListProfileConfigsRequestSchema
    output: typeof ListProfileConfigsResponseSchema
  }
  /**
   * ProfileOverridees:
   * ListProfileOverrides
   *
   * @generated from rpc plans.v1.PlansService.ListProfileOverrides
   */
  listProfileOverrides: {
    methodKind: 'unary'
    input: typeof ListProfileOverridesRequestSchema
    output: typeof ListProfileOverridesResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.DeleteProfileOverride
   */
  deleteProfileOverride: {
    methodKind: 'unary'
    input: typeof DeleteProfileOverrideRequestSchema
    output: typeof DeleteProfileOverrideResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.UpdateProfileOverride
   */
  updateProfileOverride: {
    methodKind: 'unary'
    input: typeof UpdateProfileOverrideRequestSchema
    output: typeof UpdateProfileOverrideResponseSchema
  }
  /**
   * FeatureOverride
   *
   * @generated from rpc plans.v1.PlansService.ListFeatureOverrides
   */
  listFeatureOverrides: {
    methodKind: 'unary'
    input: typeof ListFeatureOverridesRequestSchema
    output: typeof ListFeatureOverridesResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.CreateFeatureOverride
   */
  createFeatureOverride: {
    methodKind: 'unary'
    input: typeof CreateFeatureOverrideRequestSchema
    output: typeof CreateFeatureOverrideResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.DeleteFeatureOverride
   */
  deleteFeatureOverride: {
    methodKind: 'unary'
    input: typeof DeleteFeatureOverrideRequestSchema
    output: typeof DeleteFeatureOverrideResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.ListOrgProfile
   */
  listOrgProfile: {
    methodKind: 'unary'
    input: typeof ListOrgProfileRequestSchema
    output: typeof ListOrgProfileResponseSchema
  }
  /**
   * FeatureOverride
   *
   * @generated from rpc plans.v1.PlansService.CreateProfileOverride
   */
  createProfileOverride: {
    methodKind: 'unary'
    input: typeof CreateProfileOverrideRequestSchema
    output: typeof CreateProfileOverrideResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.GetUsage
   */
  getUsage: {
    methodKind: 'unary'
    input: typeof GetUsageRequestSchema
    output: typeof GetUsageResponseSchema
  }
  /**
   * @generated from rpc plans.v1.PlansService.IsEntitled
   */
  isEntitled: {
    methodKind: 'unary'
    input: typeof IsEntitledRequestSchema
    output: typeof IsEntitledResponseSchema
  }
}> = /*@__PURE__*/ serviceDesc(file_plans_v1_plans, 0)
